import { observer } from 'mobx-react-lite';
import { Box } from '@cad-arc';
import { Tooltip } from '../../../common/components/tooltip';
import {
    EventQueueRowData,
    ScheduledEventQueueRowData,
    UnitQueueRowData,
} from '../../../socket/stream-types';
import { FlagRenderer } from '../flag-renderer';
import { BaseQueueCell } from '../base-queue-cell';
import { getEventQueueRowDataOrScheduledEventQueueRowData } from '../../utils/get-event-queue-row-data';
import { getTextWithoutLineBreaks } from '../../../common/helpers/get-text-without-line-breaks';

export const NarrativeCell = observer(function NarrativeCell({
    data,
}: {
    data: EventQueueRowData | ScheduledEventQueueRowData | UnitQueueRowData;
}): React.ReactElement {
    const narrative = getEventQueueRowDataOrScheduledEventQueueRowData(data)?.narrative;
    if (!narrative) {
        return <BaseQueueCell />;
    }
    return (
        <Tooltip
            overlay={
                <Box whiteSpace="pre-line" lineHeight="1.8">
                    <FlagRenderer value={narrative} breakLines={true} />
                </Box>
            }
        >
            <BaseQueueCell>
                <FlagRenderer value={getTextWithoutLineBreaks(narrative)} />
            </BaseQueueCell>
        </Tooltip>
    );
});
